<template>
  <div v-if="!isLoadingTicket">
    <header class="border-bottom">
      <div class="rainbow-line rainbow-line-sm">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container checkoutHeader">
        <div class="row">
          <div class="col-2 col-md-2">
            <router-link
              to
              @click.native="() => $router.push({ name: 'Home Page' })"
            >
              <img src="@/assets/logos/logo-2.png" class="logoImg" />
            </router-link>
          </div>
          <div class="col-8 col-md-6 align-self-center"></div>
          <div class="col-2 text-center col-md-4 align-self-center">
            <div class="bookingFlow-close d-md-none">
              <router-link
                @click.native="() => $router.push({ name: 'Home Page' })"
                to
              >
                <img src="@/assets/img/icons/booking-flow-close-red.svg" alt />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="section-finalTicket">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-2 pr-0 pr-md-3 col-md-2 col-lg-1 text-center">
          </div>
          <div class="col-8 col-md-8 col-lg-6 text-center">
            <p class="confirm-text mob-fs-18">
              Congratulations! Your booking is confirmed.
            </p>
            <p class="d-none d-md-block">
              You have successfully booked
              {{ ticket && ticket.number_of_seats }}
              {{
                ticket && ticket.number_of_seats === 1 ? "Ticket" : "Tickets"
              }}
              for
              <span class="text-rose-gold">
                {{ ticket && ticket.Film_strTitle }} </span
              >. You will be receiving a confirmation email shortly.
            </p>
          </div>
          <div class="col-2 pl-0 pl-md-3 col-md-2 col-lg-1 text-center">
            <!-- <img
              src="@/assets/img/icons/character1.svg"
              class="img-fluid"
              alt="character Icon"
            /> -->
          </div>
        </div>

        <!-- TICKET START -->
        <div
          class="col-12 mt-3 col-md-11 col-lg-9 col-xl-8 mx-auto FinalTicket px-md-5 px-4 py-4 overflow-hidden"
        >
          <div class="row">
            <div class="col-4 col-md-3">
              <img
                v-lazy="
                  ticket && ticket.image_path_1
                    ? IMAGE_URL + ticket.image_path_1
                    : null
                "
                alt="Movie Banner"
                class="img-fluid"
              />
            </div>
            <div class="col-8 col-md-7 pl-1 pl-sm-2 pl-md-3">
              <p class="titleText font-weight-600 mb-1 text-rose-gold">
                {{ ticket && ticket.Film_strTitle }}
              </p>
              <ul
                class="list-inline titleText text-rose-gold d-none d-md-block"
              >
                <li class="list-inline-item">
                  {{ ticket && ticket.Session_dtmRealShow | dateparse }}
                  |
                  {{ ticket && ticket.Session_dtmRealShow | timeparse }}
                </li>
              </ul>
              <div class="">
                <p class="mb-0">{{ ticket && ticket.Cinema_strName }}</p>
                <p class="mb-0">{{ ticket && ticket.Screen_strName }}</p>
                <p class="mb-0">{{ ticket && ticket.cinema_address }}</p>
              </div>
            </div>
            <div class="col-md-2 d-md-block d-none text-right">
              <p class="text-center mb-0 fs-12">
                {{
                  ticket && ticket.number_of_seats === 1
                    ? "No of Ticket"
                    : "No of Tickets"
                }}
              </p>
              <p class="text-center font-weight-bold text-rose-gold mb-1 fs-30">
                {{ ticket && ticket.number_of_seats }}
              </p>

              <div v-if="ticket">
                <img
                  :src="
                    'http://api.qrserver.com/v1/create-qr-code/?data=' +
                     ticket.strBookId +
                      '+&size=100x100'
                  "
                  alt
                />
                <span class="text-left mr-1">
                  {{ ticket && ticket.strBookId }}</span
                >
              </div>
            </div>

            <div class="d-md-none col-5 mx-auto text-center mt-3" v-if="ticket">
              <img
                :src="
                  'http://api.qrserver.com/v1/create-qr-code/?data=' +
                   ticket.strBookId +
                    '+&size=100x100'
                "
                alt
              />
              <span class="text-center mt-2 small">
                {{ ticket && ticket.strBookId }}</span
              >
            </div>
          </div>

          <!-- DATE SECTION FOR MOBILE SITE -->
          <div class="row d-md-none my-4">
            <div class="col-8">
              <p class=" mb-1">Date</p>
              <p class="mb-0 titleText font-weight-bold">
                {{ ticket && ticket.Session_dtmRealShow | dateparse }}
              </p>
            </div>
            <div class="col-4 text-right">
              <p class="mb-1">Time</p>
              <p class="mb-0 titleText font-weight-bold">
                {{ ticket && ticket.Session_dtmRealShow | timeparse }}
              </p>
            </div>
          </div>
          <!-- DATE SECTION FOR MOBILE SITE -->

          <!-- SHOW THIS IF USER SELECTED F&B -->
          <div class="row mt-1 mt-md-3" v-if="ticket && ticket.items">
            <div class="col-12 col-md-10 offset-md-2">
              <div class="d-flex">
                <div class="mr-2 mt-1">
                  <img
                    src="@/assets/img/icons/popcorn-icon.svg"
                    alt="Popcorn Icon"
                  />
                </div>
                <div class>
                  <p class="mb-0">Food &amp; Beverage</p>
                  <ul
                    class="list-inline lightText fnbList"
                    v-for="(ticketItem, ticketItemIndex) in ticket.items"
                    :key="ticketItemIndex"
                  >
                    <li class="list-inline-item">
                      {{ ticketItem.quantity }}
                      {{ ticketItem.Item_strDescription }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- SHOW THIS IF USER SELECTED F&B -->

          <div class="row dividerLine my-4"></div>

          <div class="row">
            <div class="col-md-10 pr-0 seat-grid">
              <p style="width: max-content">SEAT NO.</p>
              <ul class="list-inline mb-0 seatList titleText font-weight-bold">
                <!-- v-for="(seat, seatIndex) in 5" -->
                <!--  :key="seatIndex" -->
                <li class="list-inline-item mob-fs-14">
                  {{ ticket && ticket.strSeatInfo }}
                </li>
              </ul>
            </div>
            <div class="col-2 pr-0 d-none d-md-block text-center">
              <p
                class="mb-1"
                v-if="ticket && ticket.payment_status === 'Confirmed'"
              >
                AMOUNT PAID
              </p>
              <p class="mb-1" v-else>AMOUNT PENDING</p>
              <p class="mb-0 titleText font-weight-bold">
                ₹{{ ticket && (ticket.curTotal + (ticket.convenience_fee || 0) - (ticket.DiscountAmount || 0)).toFixed(2) }}
              </p>
            </div>

            <!-- VISIBLE ON MOBILE SITE -->
            <div class="col-4 text-center lh-2 d-md-none">
              <p class="tickesNum mb-0 fs-20">
                {{ ticket && ticket.number_of_seats }}
              </p>
              <p class="titleText fs-14">
                {{
                  ticket && ticket.number_of_seats === 1 ? "Ticket" : "Tickets"
                }}
              </p>
            </div>
            <!-- VISIBLE ON MOBILE SITE -->
            <div
              class="col-12 mt-2 d-flex justify-content-between align-items-center"
            >
              <p class="mb-0">
                Booking ID:
                <span class="font-weight-bold">
                  {{ ticket && ticket.intBookId }}
                </span>
              </p>
              <p class="mb-0">
                Booking Date:
                <span class="font-weight-bold">
                  {{ ticket && ticket.transaction_time | dateparse }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <!-- TICKET END -->
        <div
          class="col-12 col-md-11 col-lg-9 col-xl-8 mx-auto px-md-5 px-4 py-4 overflow-hidden d-none d-md-block"
        >
          <div class="row">
            <div class="col-md-6 mb-3 mb-md-0">
              <router-link
                to
                class="btn btn-primary w-100"
                @click.native="
                  () =>
                    getIsUserLogged
                      ? $router.push({
                          name: 'User Profile',
                          params: { component_name: 'myTransactions' }
                        })
                      : null
                "
                >VIEW MY BOOKINGS</router-link
              >
            </div>
            <div class="col-md-6 mb-3 mb-md-0">
              <button
                class="btn btn-outline-primary w-100"
                @click="() => openGiftModal()"
              >
                SEND THIS AS A GIFT
              </button>
            </div>
          </div>
        </div>

        <div class="section-space-50"></div>
      </div>
      <!-- FINAL TICKET MOBILE BUTTONS -->
      <div class="mobile-filter-footer d-md-none">
        <!-- <div
          class="mobile-filter-btn clear-btn"
          @click="$bvModal.show('sendGift')"
        >
          Send as gift
        </div> -->
        <router-link
          to
          class="mobile-filter-btn apply-btn"
          @click.native="
            () =>
              getIsUserLogged
                ? $router.push({
                    name: 'User Profile',
                    params: { component_name: 'myTransactions' }
                  })
                : null
          "
          >View my bookings</router-link
        >
      </div>
    </section>
    <!-- SEND TICKET AS GIFT MODAL -->
    <b-modal
      id="sendGift"
      title="Send Ticket As Gift"
      class="imp-popup"
      hide-footer
    >
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row">
              <div class="col-12 my-3 px-3 text-center">
                Please enter details for the person who will receive this ticket
                as a gift.
              </div>

              <!-- ************ -->
              <form @submit.stop.prevent="onSubmitGiftSendForm()">
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      placeholder="Enter Full Name"
                      required
                      v-model="giftUserName"
                    />
                    <div class="small text-danger" v-if="noGiftUserName">
                      Please enter a name
                    </div>
                  </div>
                  <!-- vue-tel-input -->
                  <!-- <div class="col-12 mb-3">
                  <vue-tel-input v-model="phone" class="pl-0 form-control"></vue-tel-input>
                  <div class="small text-danger">Test Message</div>
                  </div>-->
                  <!-- hide if use tel-input -->
                  <div class="col-12 mb-3">
                    <div class="form-row">
                      <div class="col-3">
                        <!-- <div
                          class="has-chevron"
                          :class="countryCode ? 'chevron-inverse' : ''"
                        >
                          <input
                            type="search"
                            placeholder="+ 91"
                            v-model="searchCountry"
                            v-on:blur="countryCode = !countryCode"
                            v-on:focus="countryCode = !countryCode"
                            class="form-control"
                          />
                        </div> -->
                        <!-- <div
                          class="select-location-box countryCode"
                          v-if="countryCode"
                        >
                          <ul class="search-result-list">
                            <li
                              v-for="(countryCode, countryCodeIndex) in 10"
                              :key="countryCodeIndex"
                            >
                              +91
                            </li>
                          </ul>
                        </div> -->
                      </div>
                      <div class="col-12">
                        <input
                          type="number"
                          class="form-control"
                          id="validationCustom02"
                          placeholder="Enter Phone number"
                          required
                          v-model="giftUserNumber"
                        />
                      </div>
                    </div>
                    <div class="small text-danger" v-if="noGiftUserNumber">
                      Please enter a number
                    </div>
                  </div>
                  <!-- ********** -->
                  <div class="col-12 mb-3">
                    <textarea
                      placeholder="Type your message here.."
                      name
                      id
                      cols="30"
                      rows="5"
                      class="form-control"
                      v-model="giftUserMessage"
                    ></textarea>
                    <div class="small text-danger" v-if="noGiftUserMessage">
                      Please enter a message
                    </div>
                  </div>
                </div>

                <button class="btn btn-primary w-100" type="submit">
                  Proceed
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>

    <!-- GIFT SENT MODAL -->
    <b-modal id="GiftSentDone" title="Gift sent" class="imp-popup" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
              </div>
              <div class="col-12 text-center my-4">
                <p>
                  Congrats {{ getLoggedUser && getLoggedUser.user_name }}! The
                  ticket for {{ ticket && ticket.Film_strTitle }} has <br />been
                  sent as a gift.
                </p>
              </div>
              <div class="col-12">
                <button
                  class="btn btn-primary w-100"
                  @click="$bvModal.hide('GiftSentDone')"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import TransactionService from "@/apiServices/TransactionService";
import MasterService from "@/apiServices/MasterService";
import { mapState, mapGetters, mapActions } from "vuex";
import { IMAGEURL } from "@/config";
import Vue from "vue";
export default {
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      countryCode: false,
      searchCountry: "",
      ticket: null,
      user_name: null,
      giftUserName: null,
      noGiftUserName: false,
      giftUserNumber: null,
      noGiftUserNumber: false,
      giftUserMessage: `Now thats what friends are for! Your friend ${this.user_name} has sent you movie ticket(s) as a gift.`,
      noGiftUserMessage: false,
      isLoadingTicket: null
    };
  },
  beforeMount() {
    const { transaction_id } = this.$route.params;
    if (transaction_id) {
      this.getFinalTicket(transaction_id);
    } else {
      this.$router.go(-1);
    }
  },

  methods: {
    async getFinalTicket(transaction_id) {
      let loader = Vue.$loading.show();
      this.isLoadingTicket = true;
      try {
        this.ticket = null;
        const response = await TransactionService.GetFinalTicket({
          transaction_id,
          only_fnd: false
        });
        const { data } = response;
        if (data && data.status) {
          this.ticket = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingTicket = false;
        loader.hide();
      }
    },
    openGiftModal() {
      if (this.getIsUserLogged) {
        this.user_name = this.getLoggedUser.user_name;
      }
      this.$bvModal.show('sendGift');
      this.giftUserMessage = `Now thats what friends are for! Your friend ${this.user_name} has sent you movie ticket(s) as a gift.`
    },
    async onSubmitGiftSendForm() {
      try {
        if (!this.giftUserName) {
          this.noGiftUserName = true;
        } else if (!this.giftUserNumber) {
          this.noGiftUserNumber = true;
        } else if (!this.giftUserMessage) {
          this.noGiftUserMessage = true;
        } else {
          const { transaction_id } = this.$route.params;
          const response = await MasterService.SendTicketAsGift({
            transactionID: transaction_id,
            intBookId: this.ticket.intBookId,
            Screen_strName: this.ticket.Screen_strName,
            strSeatInfo: this.ticket.strSeatInfo,
            giftUserName: this.giftUserName,
            giftUserNumber: this.giftUserNumber,
            giftUserMessage: this.giftUserMessage,
            Film_strTitle: this.ticket.Film_strTitle,
            Session_dtmRealShow: this.ticket.Session_dtmRealShow,
            number_of_seats: this.ticket.number_of_seats,
            Cinema_strName: this.ticket.Cinema_strName
          });
          const { data } = response;
          if (data && data.status) {
            this.$bvModal.hide("sendGift");
            this.$bvModal.show("GiftSentDone");
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        // loader.hide();
      }
    }
  },
  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"])
  },
  mounted() {
    localStorage.removeItem('visibilitychangeData');
  }
};
</script>

<style scoped>
/* header {
  display: none !important;
}
.cinema-footer {
  display: none !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/finalTicket.vue